import { Component, OnInit } from '@angular/core';
import { DividentService } from 'src/app/services/divident.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { Subject } from 'rxjs';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
@Component({
  selector: 'app-dividentmandatelist',
  templateUrl: './dividentmandatelist.component.html',
  styleUrls: ['./dividentmandatelist.component.css']
})
export class DividentmandatelistComponent implements OnInit {
  isSearchDivVisible = false;

  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dividendMandateList: any[];
  deleteDividendId: any;
  nameofMember: any;
  editDividendId: any;
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  dateOfMandate: any;
  dateOfMandateTo: any;


  constructor(private dividentMandateService: DividentService, private alert: AlertComponent, 
    private router: Router,private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.getDividendMandateList();
    this.dtOptionsOfMasterDirector = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [8] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Dividend Mandate',
          title: 'Dividend Mandate',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 5, 7],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
        }
      ]
    }
  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['dividendMandate','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getDividendMandateList() {
    this.dividendMandateList = [];
    this.dividentMandateService.getDividendMandateList({ isSearch: false }).subscribe(response => {
      this.dividendMandateList = response.data;
      console.log("response ", this.dividendMandateList);
      this.dtTriggerMasterDirector.next();
    }, err => {
      console.log("error ", err);
    })

  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfMandate,
      toDate: this.dateOfMandateTo,
      name: this.nameofMember
    }
    this.dividentMandateService.generateDividendMandateDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.dividentMandateService.downloadDividendMandateFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.dividentMandateService.downloadDividendMandatePdfFile(id, 'Multi');
  }

  confirmDelete(id) {
    this.deleteDividendId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletedividenddetail() {
    this.dividentMandateService.deleteDividendMandate(this.deleteDividendId).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        $('#deleteConfirm').modal('toggle');
        $("#dividendmandatelistTable").DataTable().destroy();
      } else {
        this.alert.error(response.message);
      }
      this.getDividendMandateList();
    }, err => {
      console.log("error ", err);
    })

  }

  editdividendMandate(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['dividendMandate','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['dividendMandate/edit/', _id]);
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  doAdvSearch() {
    var searchParam =
    {
      "nameofMember": this.nameofMember,
      "dateOfMandate": this.setDate(this.dateOfMandate),
      "dateOfMandateTo": this.setDate(this.dateOfMandateTo),
      'isSearch': true,
    };

    this.dividendMandateList = [];
    $("#dividendmandatelistTable").DataTable().destroy();
    this.dividentMandateService.getDividendMandateList(searchParam).subscribe(response => {
      this.dividendMandateList = response.data;
      this.dtTriggerMasterDirector.next();
    })
  }
  clearAdvSearch() {
    this.nameofMember = '';
    this.dateOfMandate  = undefined;
    this.dateOfMandateTo = undefined;
    $("#dividendmandatelistTable").DataTable().destroy();
    this.getDividendMandateList();
  }

}

